import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase/firebase';
import { doc, setDoc } from 'firebase/firestore';
import { Box, Button, TextField, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const MakeTestPage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([{ question: '', type: 'radio', options: ['', ''], answerKey: '' }]);

  const handleAddQuestion = () => {
    setQuestions([...questions, { question: '', type: 'radio', options: ['', ''], answerKey: '' }]);
  };

  const handleSaveTest = async () => {
    const testData = { questions };
    await setDoc(doc(db, 'tests', courseId), testData);
    navigate('/admin');
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>Create Test for Course</Typography>
      {questions.map((q, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <TextField
            label="Question"
            value={q.question}
            onChange={(e) => {
              const newQuestions = [...questions];
              newQuestions[index].question = e.target.value;
              setQuestions(newQuestions);
            }}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>Question Type</InputLabel>
            <Select
              value={q.type}
              onChange={(e) => {
                const newQuestions = [...questions];
                newQuestions[index].type = e.target.value;
                setQuestions(newQuestions);
              }}
            >
              <MenuItem value="radio">Radio</MenuItem>
              <MenuItem value="checkbox">Checkbox</MenuItem>
            </Select>
          </FormControl>
          {q.options.map((option, optIndex) => (
            <TextField
              key={optIndex}
              label={`Option ${optIndex + 1}`}
              value={option}
              onChange={(e) => {
                const newQuestions = [...questions];
                newQuestions[index].options[optIndex] = e.target.value;
                setQuestions(newQuestions);
              }}
              fullWidth
              sx={{ mb: 1 }}
            />
          ))}
          <TextField
            label="Answer Key (comma-separated for multiple answers)"
            value={q.answerKey}
            onChange={(e) => {
              const newQuestions = [...questions];
              newQuestions[index].answerKey = e.target.value;
              setQuestions(newQuestions);
            }}
            fullWidth
          />
          <Button onClick={() => {
            const newQuestions = [...questions];
            newQuestions[index].options.push('');
            setQuestions(newQuestions);
          }}>Add Option</Button>
        </Box>
      ))}
      <Button variant="contained" onClick={handleAddQuestion}>Add Question</Button>
      <Button variant="contained" onClick={handleSaveTest} sx={{ ml: 2 }}>Save Test</Button>
    </Box>
  );
};

export default MakeTestPage; 